class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      const observer = new IntersectionObserver(this.handleIntersection.bind(this));
      observer.observe(this);
    }, 250);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadAccessories();
  }

  getCollectionUrl() {
    const root = window.Shopify?.routes?.root || window.routes?.root_url || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    return `${normalizedRoot}collections/accessories/products.json?limit=4`;
  }

  getImage(product) {
    const image = Array.isArray(product.images) && product.images.length ? product.images[0] : null;
    if (!image) return null;
    return typeof image === 'string' ? image : image.src;
  }

  getPrice(product) {
    const prices = (product.variants || [])
      .map(variant => Number.parseFloat(variant.price))
      .filter(price => Number.isFinite(price));
    return prices.length ? Math.min(...prices) : null;
  }

  formatPrice(price) {
    const currency = window.Shopify?.currency?.active || 'EGP';
    if (currency === 'EGP') return `LE ${price.toFixed(2)}`;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      }).format(price);
    } catch (error) {
      return `${price.toFixed(2)} ${currency}`;
    }
  }

  buildCard(product) {
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.className = 'product-container product-container--link';
    link.href = `/products/${encodeURIComponent(product.handle || '')}`;

    const imageUrl = this.getImage(product);
    if (imageUrl) {
      const imageWrapper = document.createElement('div');
      imageWrapper.className = 'product-image media-wrapper media-wrapper--small';

      const lazyImage = document.createElement('lazy-image');
      lazyImage.className = 'media media--adapt';
      lazyImage.style.setProperty('--image-ratio-percent', '125%');

      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = product.title || '';
      image.width = 280;
      image.height = 350;
      image.loading = 'lazy';

      lazyImage.appendChild(image);
      imageWrapper.appendChild(lazyImage);
      link.appendChild(imageWrapper);
    } else {
      link.classList.add('no-image');
    }

    const description = document.createElement('div');
    description.className = 'product-description';

    const content = document.createElement('div');
    content.className = 'product-content';

    const title = document.createElement('span');
    title.className = 'link product-title';
    title.textContent = product.title || '';

    content.appendChild(title);
    description.appendChild(content);

    const price = this.getPrice(product);
    if (price !== null) {
      const priceBox = document.createElement('div');
      priceBox.className = 'price';
      const priceMoney = document.createElement('price-money');
      const bdi = document.createElement('bdi');
      bdi.textContent = this.formatPrice(price);
      priceMoney.appendChild(bdi);
      priceBox.appendChild(priceMoney);
      description.appendChild(priceBox);
    }

    link.appendChild(description);
    item.appendChild(link);
    return item;
  }

  loadAccessories() {
    fetch(this.getCollectionUrl(), { credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error(`Accessories request failed: ${response.status}`);
        return response.json();
      })
      .then(data => {
        const products = Array.isArray(data.products) ? data.products.slice(0, 4) : [];
        const list = this.querySelector('.mini-cart__navigation');
        if (!list || !products.length) return;

        list.replaceChildren(...products.map(product => this.buildCard(product)));
        this.dataset.fixedCollection = 'accessories';
      })
      .catch(error => console.error('4PIXELS fixed cart accessories:', error));
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}
